// 22.01.19 - This reducer controls all the states for the app. It specifies how the app's state changes in response to actions sent to the store. Takes the previous state and returns the new state.
import { Reducer } from "redux";
import { ActionTypes } from "../constants/actions";
import {
  ICase,
  IUserDetail
  // IIssueType,
  // ICountry,
  // IssueType,
  // IClaimStatus,
} from "src/constants/api";

// This function converts an array to a map. Use for cases, countries and master tables.
function normalizeArray<T, K extends keyof T>(
  array: T[],
  indexKey: K
): ReadonlyMap<T[K], T> {
  const mapFn: (x: T) => [T[K], T] = x => [x[indexKey], x];
  const entries: ReadonlyArray<[T[K], T]> = array.map(mapFn);
  const m: ReadonlyMap<T[K], T> = new Map(entries);
  return m;
}

// This interface describes the structure of the state of all the data in the app. The ones withn the ? are optional and can be undefined.
export interface IHomeState {
  caseData?: ReadonlyMap<string | undefined, ICase>;
  currentUser?: IUserDetail;
  gridData?: any;
  loggedUserData: null,
  showNoDataMessage: boolean;

}

// This is the default state when the app starts.
const initialState: IHomeState = {
  currentUser: undefined,
  showNoDataMessage: false,
  loggedUserData: null,
};

// All the state updates takes place here.
export const homeReducer: Reducer<IHomeState> = (
  // This will be called when the app loads and no state is passed.
  state: IHomeState = initialState,
  action: any
) => {
  switch (action.type) {
    case ActionTypes.HOME.USER_DATA_RECEIVED: // Reads the userroles etc.
      return {
        ...state,
        currentUser: action.payload // Here the state is updated with the data received from
      };
    case ActionTypes.HOME.FETCH_LOGGED_USER_DATA_SUCCESS: // Reads the userroles etc.
      return {
        ...state,
        loggedUserData: action.payload // Here the state is updated with the data received from
      };
    case ActionTypes.HOME.SUCCESS_GET_ALL_CASES: // Receives all cases sucessfully read.
      return {
        // Spreads everything contained in state except for caseData which we assign ourselves
        ...state,
        // normalizeArray converts an array of objects into a `Map` given a key -- in this example
        // we get a map that maps from a uniqueId to the case -- this representation is much simpler to work with for most purposes
        caseData: normalizeArray(action.payload, "uniqueId")
      };

    case ActionTypes.HOME.SUCCESS_GET_GRID_DATA: {
      return {
        ...state,
        gridData: action.payload || []
      };
    }

    case ActionTypes.HOME.SHOW_NO_DATA_MESSAGE: {
      return {
        ...state,
        showNoDataMessage: action.payload
      };
    }

    default:
      return state;
  }
};
